import { Config_Club_PageMenu_ApiEnum } from './ClubDetailConfigApiInterface';
import { ConfigDataInterface } from './ConfigApiInterface';

export enum Config_ClubAccountIssuedDocuments_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_ClubAccountIssuedDocuments_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'results' = 'results',
}

export enum Config_ClubAccountIssuedDocuments_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_ClubAccountIssuedDocuments_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_ClubAccountIssuedDocuments_ApiInterface
    extends ConfigDataInterface<
        Config_ClubAccountIssuedDocuments_Modules_ApiEnum,
        Config_ClubAccountIssuedDocuments_ActionsMenu_ApiEnum,
        Config_ClubAccountIssuedDocuments_ActionsOther_ApiEnum,
        Config_Club_PageMenu_ApiEnum,
        Config_ClubAccountIssuedDocuments_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
